/* eslint-disable react/display-name */
"use client";
import React from "react";
import style from "./index.module.scss";
import Radio from '@mui/material/Radio';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import ContactInfoValidTool from "./validTool";
import UKUpload from "@/common-components-src/components/UKUpload";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25630"
import { EXPCONFIG_DELAY } from "@/common-components-src/const/point";
import IMAGEAPI_TYPE from "@/common-components-src/const/imageApiType";
import RedClose from "@/common-components-src/assets/icons/redClose.svg";
import UKToast from '@/common-components-src/components/UKToast/index.tsx';
import UKDialog from '@/common-components-src/components/UKDialog/index.tsx'
import { fetchFeedbackSubmit, fetchFeedbackGetList } from "@/apis/feedback/feedback.api"
import { DialogContent, DialogTitle, Button, FormControl, FormControlLabel, OutlinedInput, FormHelperText } from "@mui/material";
import { DialogStyle, DialogTitleStyle, DialogContentStyle, FlexRightStyle, SubjectTitleStyle, DescTitleStyle, ContactTitleStyle, SubjectFormStyle, 
  DescFormStyle, ContactFormStyle, OutlinedInputStyle, ContactInputStyle, RadioLabelStyle, RadioColorStyle, CancelBTnStyle, SubmitBTnStyle } from "./style";

const FeedbackDialog = ({ type, open, closeFn, param }) => {

  const textError = "This must include at least 10 characters.";
  const validMsg = "Please enter a valid email address or a valid phone number";

  const maxImgCount = 5;//最大上传图片数量
  const textMinCount = 10;//最少输入字数
  const maxSubjectCount = 100;//最大输入字数
  const maxCharacterCount = 1400;//描述最大输入字数

  const [isOpen, setIsOpen] = useState(false); // 弹框控制器
  const [isPageLoading, setIsPageLoading] = useState(true); // 页面加载中
  const [subjectInfoList, setSubjectInfoList] = useState([]); // 反馈问题列表

  const [emailValue, setEmailValue] = useState(""); // email输入框的value值
  const [desValue, setDesValue] = useState(""); // desc输入框的value值
  const [descCount, setDescCount] = useState(0); //desc输入框的文本个数
  const [chooseOther, setChooseOther] = useState(false); // 是否显示其他问题输入框
  const [helperTextError, setHelperTextError] = useState(""); // 输入框错误提示
  const [descHelperTextError, setDescHelperTextError] = useState(""); // desc输入框错误提示
  
  const [selectedValue, setSelectedValue] = useState("0"); // 默认选中
  const [isSubmitting, setIsSubmitting] = useState(false); // 正在提交中
  const [mediaList, setMediaList] = useState([]); // 图片数组
  const [isLoading, setIsLoading] = useState(false); // 图片加载中

  const [subjectValue, setSubjectValue] = useState(""); // 输入框的值
  const [subjectCount, setSubjectCount] = useState(0); //输入框的文本个数
  const [subjectRadio, setSubjectRadio] = useState(1); // 需要反馈的问题类型
  const [subjectRadioTitle, setSubjectRadioTitle] = useState(""); // 需要反馈的问题标题
  const [subjectTextError, setSubjectTextError] = useState(""); // subject输入框错误提示

  const [subjectValueList, setSubjectValueList] = useState({}); // 输入框的值
  const [subjectCountList, setSubjectCountList] = useState({}); //输入框的文本个数
  const [subjectTextErrorList, setSubjectTextErrorList] = useState({}); // subject输入框错误提示

  useEffect(() => {
    getFeedbackList();
  }, [])

  useEffect(() => {
    setIsOpen(open);
  }, [open])

  useEffect(() => {
    let count = desValue ? desValue.length : 0
    setDescCount(count)
  }, [desValue])

  const getFeedbackList = async () => {
    const res = await fetchFeedbackGetList({ sourceType: type });
    if(res && res.data && res.code === "200"){
      setSubjectInfoList(res.data.subjectInfoDTOList);
    }
    setIsPageLoading(false);
  };

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  }

  const handleRadioChange = (radioValue, radioSubjct, showInputBox = false) => {
    setSelectedValue(radioValue);
    setSubjectRadio(radioValue);
    setSubjectRadioTitle(radioSubjct);
    setChooseOther(showInputBox);
    setSubjectCount(showInputBox ? subjectCountList[radioValue] || 0 : 0);
    setSubjectValue(showInputBox ? subjectValueList[radioValue] || "" : "");
    setSubjectTextError(showInputBox ? subjectTextErrorList[radioValue] || "" : "");
  };

  const handleSubjectOnBlur = (key) => {
    const realKey = key || parseInt(subjectRadio);
    const value = subjectCount && subjectCount < textMinCount ? textError : "";
    setSubjectTextError(value);
    setSubjectTextErrorList({...subjectTextErrorList, [realKey]: value});
  };

  const handleSubjectValueChange = (key, value) => {
    const count = value ? value.length : 0;
    setSubjectValue(value);
    setSubjectValueList({...subjectValueList, [key]: value});
    setSubjectCount(count);
    setSubjectCountList({...subjectCountList, [key]: count});
  }

  const handleDescOnBlur = () => {
    setDescHelperTextError(descCount && descCount < textMinCount ? textError : "");
  };

  const handleEmailValueChange = (value) => {
    if (value) {
      let isPhone = ContactInfoValidTool.isPhone(value)
      let isValid = isPhone ? ContactInfoValidTool.isPhonePattern(value) : ContactInfoValidTool.isEmailPattern(value)
      setHelperTextError(isValid ? "" : validMsg)
    }
    else {
      setHelperTextError("")
    }
    setEmailValue(value)
  };

  const OnCancel = () => {
    closeHandler()
    sendClickTrack.Feedback_Pop({ button_name: "Cancel" })
  };

  const OnSubmit = () => {
    handleDescOnBlur()
    handleSubjectOnBlur()
    sendClickTrack.Feedback_Pop({ button_name: "Submit" })
    if (isSubmitting) {
      return
    }
    if (!!helperTextError || !!descHelperTextError || !!subjectTextError) {
      return
    }
    if (isLoading) {
      UKToast.show({
        icon: 'fail',
        content: 'Oops! The image is still uploading, please try again later.',
      })
      return
    }
    OnSubmitApi();
  };

  const OnSubmitApi = async () => {
    const params = {
      sourceType: type,
      subjectType: parseInt(subjectRadio),
      subject: chooseOther ? subjectValue : subjectRadioTitle,
      feedbackDetails: desValue,
      feedbackAttachments: mediaList,
      email: emailValue,
      platform: 3,
      appVersion: "",
      extMap: param || {},
    }
    setIsSubmitting(true);
    fetchFeedbackSubmit(params).then((res) => {
      if (res && res.success) {
        UKToast.show({
          icon: 'success',
          content: 'Submitted successful!',
        })
        closeHandler();
      }
      else {
        setIsSubmitting(false);
        UKToast.show({
          icon: 'fail',
          content: 'Oops! Something went wrong. Please try again',
        })
      }
    });
  }

  if (isPageLoading) {
    return
  }

  function IconButtonContent() {
    return (
      <IconButton
        aria-label="close"
        onClick={closeHandler}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
    )
  }

  function SubjectInfoContent() {
    return (
      <div className={style.form__radio}>
        { subjectInfoList && !!subjectInfoList.length && subjectInfoList.map((info, index) => {
            if(info){
              return (
                <div key={index}>
                  <FormControlLabel sx={RadioLabelStyle} label={info.subject} control={
                    <Radio sx={RadioColorStyle} checked={selectedValue === String(info.subjectType)} onChange={(event) => handleRadioChange(event.target.value, info.subject, info.showInputBox)} value={String(info.subjectType)} />
                  }/>
                  {
                    info && info.showInputBox && selectedValue === String(info.subjectType) && (
                      <div style={FlexRightStyle} className={style.input__wrap}>
                      <FormControl sx={SubjectFormStyle} id="outlined-subject" variant="outlined" error={!!subjectTextError}>
                        <OutlinedInput
                          type="text"
                          multiline
                          minRows={2}
                          maxRows={2}
                          value={subjectValue}
                          sx={OutlinedInputStyle}
                          inputProps={{ maxLength: 100 }}
                          placeholder={"Your feedback subject is important! Please enter a minimum of 10 characters or more."}
                          onChange={(event) => handleSubjectValueChange(info.subjectType, event.target.value)}
                          onBlur={() => handleSubjectOnBlur(info.subjectType)}
                        />
                        {!!subjectTextError && (
                          <FormHelperText>
                            <span className={style.error_text}>
                              <RedClose />
                              {subjectTextError}
                            </span>
                          </FormHelperText>
                        )}
                      </FormControl>
                      <span className={style.input_text}>
                        <span className={style.input_text_color}>{subjectCount}</span>
                        <span>/{maxSubjectCount}</span>
                      </span>
                    </div>
                  )}
                </div>
            )}
        })}
      </div>
    )
  }
  
  function DescInputContent() {
    return (
      <div className={style.input__wrap}>
        <FormControl sx={DescFormStyle} id="outlined-basic" variant="outlined" fullWidth error={!!descHelperTextError}>
          <OutlinedInput
            multiline
            minRows={4}
            maxRows={4}
            type="text"
            value={desValue}
            sx={OutlinedInputStyle}
            inputProps={{ maxLength: 1400 }}
            placeholder={"Please describe your experiences in detail with a minimum requirement of 10 characters."}
            onChange={(event) => setDesValue(event.target.value)}
            onBlur={handleDescOnBlur}
          />
          {!!descHelperTextError && (
            <FormHelperText>
              <span className={style.error_text}>
                <RedClose />
                {descHelperTextError}
              </span>
            </FormHelperText>
          )}
        </FormControl>
        <span className={style.input_text}>
          <span className={style.input_text_color}>{descCount}</span>
          <span>/{maxCharacterCount}</span>
        </span>
      </div>
    )
  }

  function ContactInfoContent() {
    return <>
      <div style={ContactTitleStyle} className={style.form__title}><span>*</span><em> Contact information</em></div>
      <FormControl sx={ContactFormStyle} id="outlined-basic" variant="outlined" fullWidth>
        <OutlinedInput
          type="text"
          multiline
          maxRows={2}
          value={emailValue}
          sx={ContactInputStyle}
          placeholder={"Please enter your email address or phone number."}
          onChange={(event) => handleEmailValueChange(event.target.value)}
        />
        {!!helperTextError && (
          <FormHelperText>
            <span className={style.error_text}>
              <RedClose />
              {helperTextError}
            </span>
          </FormHelperText>
        )}
      </FormControl>
    </>
  }

  return (
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={false} sx={DialogStyle}>
      <DialogTitle sx={DialogTitleStyle}>Feedback</DialogTitle>
      <IconButtonContent/>
      <DialogContent sx={DialogContentStyle}>
        <div
          className={style.dialogcontent__wrap}
          exptag={"exp|" + EXPOSURE_RECORD.Feedback_Pop_Expo}
          data-exptag-config={EXPCONFIG_DELAY}
        >
          <div style={SubjectTitleStyle} className={style.form__title}><span>*</span><em> Subject</em></div>
          { SubjectInfoContent() }
          <div style={DescTitleStyle} className={style.form__title}><em>Detailed description</em></div>
          { DescInputContent() }
          <div className={style.upload__footer}>Uploading an image will assist you in better describing the issue. You can upload up to 5 images.</div>
          <UKUpload
            type="image"
            limitNumber={maxImgCount}
            containStyle={{ gap: "4px" }}
            apiType={IMAGEAPI_TYPE.FeedBack}
            onChange={(media) => setMediaList(media)}
            onLoadingChange={(loading) => setIsLoading(loading)}
          />
          { ContactInfoContent() }
          <div className={style.dialog__footer}>
            <Button sx={CancelBTnStyle} onClick={OnCancel}>Cancel</Button>
            <Button sx={SubmitBTnStyle} onClick={OnSubmit} disableElevation disabled={ !emailValue || !!helperTextError || !!descHelperTextError || !!subjectTextError || selectedValue === "0"}>Submit</Button>
          </div>
        </div>
      </DialogContent>
    </UKDialog >
  );
};

export default FeedbackDialog;
